/**
 * @generated SignedSource<<788371e67f6826fc28222de1ce67d2f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamSelector_account$data = {
  readonly teams: ReadonlyArray<{
    readonly id: number;
    readonly name: string;
  }>;
  readonly " $fragmentType": "TeamSelector_account";
};
export type TeamSelector_account$key = {
  readonly " $data"?: TeamSelector_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamSelector_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamSelector_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "teams",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "accounts",
  "abstractKey": null
};

(node as any).hash = "7b221ec54485e7cf2868ee29a5da88a5";

export default node;
